// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3FlX8","bigColWidth":"Table_bigColWidth__2CJEA","biggerColWidth":"Table_biggerColWidth__35qDn","row":"Table_row__1_9fX","col":"Table_col__2vPdK"};